
import { store } from '../../store';
import Rest from '../../webapi/Rest';
import BaseActions from '../../app/_base_actions';
import update from 'immutability-helper';
import AppActions from '../../app/app_actions';
import { Utils, DateFormatter, domain, i18n } from 'arm-common';


const EnumGaranzieActions = Object.freeze({

    GARANZIE_LIST: 'GARANZIE_LIST',
    GARANZIE_INITIALIZED: 'GARANZIE_INITIALIZED',
    GARANZIA_DETAILS: 'GARANZIA_DETAILS',
    GARANZIE_HANDLE_CHANGE: 'GARANZIE_HANDLE_CHANGE',
    RF_HANDLE_CHANGE: 'RF_HANDLE_CHANGE',
    RF_DETAILS: 'RF_DETAILS',
    GARANZIE_UPDATE: 'GARANZIE_UPDATE'


});

module.exports.EnumGaranzieActions = EnumGaranzieActions;


class GaranzieActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "[GaranzieActions] ";
    }
    get Actions() {

        return EnumGaranzieActions;
    }





    getListGaranzie() {
        return function (dispatch) {
            return Rest.post('admin/garanzia/listaGaranzie', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumGaranzieActions.GARANZIE_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
    getGaranziaDetails(Id) {
        return function (dispatch) {
            return Rest.postForm('admin/garanzia/getGaranziaById', { id: Id }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumGaranzieActions.GARANZIA_DETAILS, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }
    clearAll() {
        return function (dispatch) {
            dispatch({ type: EnumGaranzieActions.GARANZIE_INITIALIZED });
        }
    }

    handleChange(index, e) {
        return function (dispatch) {
            let object = {};
            object[index] = e;
            dispatch({
                type: EnumGaranzieActions.GARANZIE_HANDLE_CHANGE,
                dato: object
            });
        }
    }
    handleChangeRF(index, e) {
        return function (dispatch) {
            let object = {};
            object[index] = e;
            dispatch({
                type: EnumGaranzieActions.RF_HANDLE_CHANGE,
                dato: object
            });
        }
    }

    salvaGaranzia(history) {
        return function (dispatch, getState) {
            let garanziaToSave = new Object();
            garanziaToSave = getState().garanzie.detailsGaranzia;
            return Rest.post("admin/garanzia/salvaGaranzia", garanziaToSave, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumGaranzieActions.GARANZIA_DETAILS, dati: resolve });
                    if (garanziaToSave.id === null || garanziaToSave.id === undefined) {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.GARANZIE.GARANZIA_INSERITA_CON_SUCCESSO', 'Garanzia inserita con successo')));
                    } else {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.GARANZIE.GARANZIA_MODIFICATA_CON_SUCCESSO', 'Garanzia modificata con successo')));
                    }
                    history.push({ pathname: '/garanzie/details', state: { id: resolve.id } })
                    return resolve;
                },
                function (reject) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.GARANZIE.NON_SI_PUO_INSERIRE_GARANZIA', 'Non si puo inserire la garanzia')));
                    return reject;
                });
        }
    }
    deleteGaranzia() {
        return function (dispatch, getState) {
            let id = getState().garanzie.detailsGaranzia.id;

            let microCategoriaGar = getState().garanzie.detailsGaranzia?.listaGruppiProdottoConGaranzia;
            if (microCategoriaGar != null && microCategoriaGar != undefined && microCategoriaGar.length > 0) {
                let messaggioErrore = "ATTENZIONE! La Garanzia che si sta eliminando è asscociata ad una micro-categoria. " 
                dispatch(AppActions.addNotify('DANGER', messaggioErrore));
                 return Promise.reject()
            }
            return Rest.postForm('admin/garanzia/eliminaGaranzia', { id: id }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumGaranzieActions.GARANZIA_DETAILS, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.GARANZIE.GARANZIA_ELIMINATA_CON_SUCCESSO', 'Garanzia eliminata con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
    salvaRF(history) {
        return function (dispatch, getState) {
            let regimeFiscaleToSave = getState().garanzie.regimeFiscale;
            let garanzia = getState().garanzie.detailsGaranzia;
            regimeFiscaleToSave.nomeEntity = "GARANZIA";
            regimeFiscaleToSave.idEntity = garanzia.id;
            if (regimeFiscaleToSave.valoreAliquota !== undefined
                && regimeFiscaleToSave.valoreAliquota !== null
                && isNaN(regimeFiscaleToSave.valoreAliquota)) {
                // let temp = regimeFiscaleToSave.valoreAliquota;
                regimeFiscaleToSave.valoreAliquotaStr = regimeFiscaleToSave.valoreAliquota;
                regimeFiscaleToSave.valoreAliquota = null;

            }
            return Rest.post("admin/regimeFiscale/salvaRegimeFiscale", regimeFiscaleToSave, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumGaranzieActions.RF_DETAILS, dati: resolve });
                    if (regimeFiscaleToSave.id === null || regimeFiscaleToSave.id === undefined) {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.GARANZIE.REGIME_FISCALE_INSERITA_CON_SUCCESSO', 'Regime fiscale inserita con successo')));
                    } else {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.GARANZIE.REGIME_FISCALE_MODIFICATA_CON_SUCCESSO', 'Regime fiscale modificata con successo')));
                    }
                    history.push({ pathname: '/garanzie/details', state: { id: resolve.idEntity } })
                    return resolve;
                },
                function (reject) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.GARANZIE.NON_SI_PUO_INSERIRE_GARANZIA', 'Non si puo inserire la garanzia')));
                    return reject;
                });
        }
    }
    getRFDetails(Id) {
        return function (dispatch) {
            return Rest.postForm('admin/regimeFiscale/regimeFiscaleDetails', { id: Id }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumGaranzieActions.RF_DETAILS, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }
    inizializzaRFEdit() {

        return function (dispatch, getState) {
            let valoriAliquota = domain("AI_TIPO_ALIQUOTA");
        }
    }

    getTipiAliquota(nomeEntity) {
        return function (dispatch, getState) {
            let tipiAliquota = domain("AI_TIPO_ALIQUOTA");
            if (tipiAliquota !== null && tipiAliquota !== undefined) {
                tipiAliquota.forEach(
                    function (element, index) {

                        let info = element.info;
                        if (info !== null && info !== undefined) {
                            let str = info.split('REF=')[1].split(';')[0];
                            str = str.replace(';', '');
                            let values = str.split("*");
                            if (!values.includes(nomeEntity)) {
                                tipiAliquota.splice(index, 1);
                            }
                        }
                    });
            }



            let garanzie = {
                tipiAliquote:
                {
                    $set: tipiAliquota
                },
            }
            // // } else {
            // //     garanzie = {
            // //         valoriAliquote:
            // //         {
            // //             $set: []
            // //         }
            // //     }
            // }

            dispatch({
                type: EnumGaranzieActions.GARANZIE_UPDATE,
                garanzie: garanzie
            });

        }
    }

    handleChangeTipoAliquota(index, e) {
        return function (dispatch, getState) {
            let object = {};
            let values = [];
            let valoreAliquotaForzata = false;
            let valoreAliquotaSelezionata = "";

            valoreAliquotaSelezionata = getState().garanzie.regimeFiscale.valoreAliquota;
            // let valid = false;

            object[index] = e;
            dispatch({
                type: EnumGaranzieActions.RF_HANDLE_CHANGE,
                dato: object
            });
            let valoriAliquota = domain("AI_TIPO_ALIQUOTA");



            let domainIndex = valoriAliquota.findIndex(dom => dom.valCampo === e);
            if (domainIndex !== null && domainIndex !== -1) {
                // valid = true;
                let info = valoriAliquota[domainIndex].info;

                let str = info.split('VALORI:')[1].split(';')[0];
                str = str.replace(';', '');
                values = str.split("_");

                let valoreAliquotaForzataInfo = info.split('FORZA:')[1].split(';')[0];
                if (valoreAliquotaForzataInfo !== undefined
                    && valoreAliquotaForzataInfo !== null
                    && valoreAliquotaForzataInfo === "SI") {
                    valoreAliquotaForzata = true;
                }
                if (values !== null && values.length === 1) {
                    valoreAliquotaSelezionata = values[0];
                }
                // for (let i = 0; i < values.lenght; i++) {
                //     if (isNaN(values[i])) {
                //         valid = false;
                //         break;
                //     }
                // }
            }
            let garanzie = {};
            // if (valid) {

            garanzie = {
                valoriAliquote:
                {
                    $set: values
                },
                regimeFiscale: {
                    valoreAliquotaForzata: {
                        $set: valoreAliquotaForzata
                    },
                    valoreAliquota: {
                        $set: valoreAliquotaSelezionata
                    }
                }
            }
            // // } else {
            // //     garanzie = {
            // //         valoriAliquote:
            // //         {
            // //             $set: []
            // //         }
            // //     }
            // }

            dispatch({
                type: EnumGaranzieActions.GARANZIE_UPDATE,
                garanzie: garanzie
            });
        }



    }
    clearRF() {
        return function (dispatch) {

            let garanzie = {
                valoriAliquote: {
                    $set: []

                },
                regimeFiscale: {
                    $set: {}
                }

            }

            dispatch({
                type: EnumGaranzieActions.GARANZIE_UPDATE,
                garanzie: garanzie
            });


        }


    }

    deleteRF(history) {
        return (dispatch, getState) => {
            let regimeFiscale = getState().garanzie.regimeFiscale;

            return Rest.postForm('admin/regimeFiscale/eliminaRegimeFiscale', { id: regimeFiscale.id }, dispatch).then(
                function (resolve) {

                    history.push({ pathname: '/garanzie/details', state: { id: regimeFiscale.idEntity } })
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.GARANZIE.REGIME_FISCALE_ELIMINATA_CON_SUCCESSO', 'Regime Fiscale eliminata con successo')));


                    return dispatch(this.getGaranziaDetails(regimeFiscale.idEntity));
                },
                function (reject) {
                    return reject;
                });
        }

    }

    inizializzaNuovaGaranziaDalGP() {
        return (dispatch, getState) => {

            let detailsGaranzia = {
                idMicroCategoria: getState().microCategorie.detailsMC.id,
                nomeMicroCategoria: getState().microCategorie.detailsMC.nome
            }
            let garanzie = {
                detailsGaranzia: {
                    $set: detailsGaranzia
                }
            }

            dispatch({
                type: EnumGaranzieActions.GARANZIE_UPDATE,
                garanzie: garanzie
            });
            return Promise.resolve();
        }
    }

    inizializzaNuovaGaranziaDalProdotto() {
        return (dispatch, getState) => {

            let detailsGaranzia = {
                idMicroCategoria: getState().prodotto.detailsProdotto.microCategoria.id,
                nomeMicroCategoria: getState().prodotto.detailsProdotto.microCategoria.nome
            }
            let garanzie = {
                detailsGaranzia: {
                    $set: detailsGaranzia
                }
            }

            dispatch({
                type: EnumGaranzieActions.GARANZIE_UPDATE,
                garanzie: garanzie
            });
            return Promise.resolve();
        }
    }

    getListaGruppiProdottoConGaranzia() {
        return function (dispatch, getState) {

            let garanziaId = getState().garanzie.detailsGaranzia.id
            return Rest.postForm('admin/microCategoria/listaMicroCategorieConGaranzia', { idGaranzia: garanziaId }, dispatch).then(
                resolve => {

                    let garanzie = {

                        detailsGaranzia: {
                            listaGruppiProdottoConGaranzia: {
                                $set: resolve
                            }
                        }
                    }

                    dispatch({
                        type: EnumGaranzieActions.GARANZIE_UPDATE,
                        garanzie: garanzie
                    });

                    dispatch({ type: EnumGaranzieActions.GARANZIE_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    searchProdottiOfGaranzia() {

        return function (dispatch, getState) {

            let detailsGaranzia = getState().garanzie.detailsGaranzia;

            let psp = getState().prodotto.psp;
            psp.idGaranzia = detailsGaranzia.id;

            if (psp.dataValidita !== undefined && psp.dataValidita !== null) {
                let data = new Date(psp.dataValidita);
                psp.dataValidita = data.getTime();

            }

            return Rest.post('admin/prodotto/ricercaProdotti', psp, dispatch).then(
                resolve => {
                    detailsGaranzia.listProdottiOfGaranzia = resolve;
                    dispatch({ type: EnumGaranzieActions.GARANZIA_DETAILS, dati: detailsGaranzia });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }


};

export default GaranzieActions = new GaranzieActions;
